import { isTag } from 'domhandler';
import { Picker } from 'selderee';
function hp2Builder(nodes) {
  return new Picker(handleArray(nodes));
}
function handleArray(nodes) {
  const matchers = nodes.map(handleNode);
  return function (el) {
    for (var _len = arguments.length, tail = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      tail[_key - 1] = arguments[_key];
    }
    return matchers.flatMap(m => m(el, ...tail));
  };
}
function handleNode(node) {
  switch (node.type) {
    case 'terminal':
      {
        const result = [node.valueContainer];
        return function (el) {
          return result;
        };
      }
    case 'tagName':
      return handleTagName(node);
    case 'attrValue':
      return handleAttrValueName(node);
    case 'attrPresence':
      return handleAttrPresenceName(node);
    case 'pushElement':
      return handlePushElementNode(node);
    case 'popElement':
      return handlePopElementNode(node);
  }
}
function handleTagName(node) {
  const variants = {};
  for (const variant of node.variants) {
    variants[variant.value] = handleArray(variant.cont);
  }
  return function (el) {
    const continuation = variants[el.name];
    for (var _len2 = arguments.length, tail = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      tail[_key2 - 1] = arguments[_key2];
    }
    return continuation ? continuation(el, ...tail) : [];
  };
}
function handleAttrPresenceName(node) {
  const attrName = node.name;
  const continuation = handleArray(node.cont);
  return function (el) {
    for (var _len3 = arguments.length, tail = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      tail[_key3 - 1] = arguments[_key3];
    }
    return Object.prototype.hasOwnProperty.call(el.attribs, attrName) ? continuation(el, ...tail) : [];
  };
}
function handleAttrValueName(node) {
  const callbacks = [];
  for (const matcher of node.matchers) {
    const predicate = matcher.predicate;
    const continuation = handleArray(matcher.cont);
    callbacks.push(function (attr, el) {
      for (var _len4 = arguments.length, tail = new Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
        tail[_key4 - 2] = arguments[_key4];
      }
      return predicate(attr) ? continuation(el, ...tail) : [];
    });
  }
  const attrName = node.name;
  return function (el) {
    for (var _len5 = arguments.length, tail = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
      tail[_key5 - 1] = arguments[_key5];
    }
    const attr = el.attribs[attrName];
    return attr || attr === '' ? callbacks.flatMap(cb => cb(attr, el, ...tail)) : [];
  };
}
function handlePushElementNode(node) {
  const continuation = handleArray(node.cont);
  const leftElementGetter = node.combinator === '+' ? getPrecedingElement : getParentElement;
  return function (el) {
    const next = leftElementGetter(el);
    if (next === null) {
      return [];
    }
    for (var _len6 = arguments.length, tail = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
      tail[_key6 - 1] = arguments[_key6];
    }
    return continuation(next, el, ...tail);
  };
}
const getPrecedingElement = el => {
  const prev = el.prev;
  if (prev === null) {
    return null;
  }
  return isTag(prev) ? prev : getPrecedingElement(prev);
};
const getParentElement = el => {
  const parent = el.parent;
  return parent && isTag(parent) ? parent : null;
};
function handlePopElementNode(node) {
  const continuation = handleArray(node.cont);
  return function (el, next) {
    for (var _len7 = arguments.length, tail = new Array(_len7 > 2 ? _len7 - 2 : 0), _key7 = 2; _key7 < _len7; _key7++) {
      tail[_key7 - 2] = arguments[_key7];
    }
    return continuation(next, ...tail);
  };
}
export { hp2Builder };